import React from 'react';
import { Box, Typography, Button, Paper, Fade } from '@mui/material';
import { useGame } from '../../contexts/GameContext';

export default function BaseRound({ 
  instructions,
  children,
  onComplete,
  showResult,
  resultData
}) {
  const { nextRound, updateScore } = useGame();

  const handleComplete = () => {
    if (resultData) {
      // Update the score based on the result
      if (resultData.success) {
        updateScore(resultData.player, resultData.points || 0, 0);
      } else {
        updateScore(resultData.player, 0, resultData.drinks || 0);
      }
    }
    
    if (onComplete) {
      onComplete();
    }
    nextRound();
  };

  if (showResult && resultData) {
    return (
      <Fade in timeout={500}>
        <Box>
          <Paper 
            sx={{ 
              p: 3, 
              bgcolor: 'background.default',
              borderRadius: 3,
              border: '2px solid',
              borderColor: resultData.success ? 'success.main' : 'error.main',
              mb: 2
            }}
          >
            <Typography 
              variant="h6" 
              align="center" 
              gutterBottom
              sx={{ color: resultData.success ? 'success.main' : 'error.main' }}
            >
              {resultData.title}
            </Typography>
            
            {resultData.customText ? (
              <Typography 
                variant="h5" 
                align="center" 
                sx={{ 
                  mt: 2,
                  color: 'text.primary',
                  fontWeight: 'bold'
                }}
              >
                {resultData.customText}
              </Typography>
            ) : (
              <Typography 
                variant="h5" 
                align="center" 
                sx={{ 
                  mt: 2,
                  color: resultData.success ? 'success.main' : 'error.main',
                  fontWeight: 'bold'
                }}
              >
                {resultData.success ? (
                  `${resultData.drinks} Schlücke verteilen! 🎉`
                ) : (
                  `${resultData.drinks} Schlücke trinken! 🍺`
                )}
              </Typography>
            )}
          </Paper>

          <Button 
            variant="contained" 
            color="primary"
            onClick={handleComplete}
            fullWidth
            sx={{
              mt: 2,
              py: 1.5,
              fontSize: '1.1rem',
            }}
          >
            Runde Beenden
          </Button>
        </Box>
      </Fade>
    );
  }

  return (
    <Box>
      {instructions && (
        <Typography 
          variant="body1" 
          sx={{ 
            mb: 2,
            color: 'text.secondary',
            fontSize: '1rem',
          }}
        >
          {instructions}
        </Typography>
      )}

      <Box sx={{ my: 2 }}>
        {children}
      </Box>
    </Box>
  );
} 